import { useTranslation } from "react-i18next";
import { Bot, Loader2 } from "lucide-react";
import { Card, CardContent, Button } from "@tabipla/ui";
import { TRIP_TYPE_TEMPLATES, type TripType } from "./constants";
import { usePackingAiSuggestions, usePackingTemplates } from "./PackingContext";

export function EmptyPackingList() {
  const { t } = useTranslation();
  const { isAiLoading, onAiSuggest } = usePackingAiSuggestions();
  const { isBulkCreating, onSelectTemplate } = usePackingTemplates();

  return (
    <Card>
      <CardContent className="p-6">
        {/* AI Suggest Button - Prominent */}
        <div className="mb-6">
          <Button onClick={onAiSuggest} disabled={isAiLoading} className="w-full gap-2" size="lg">
            {isAiLoading ? (
              <>
                <Loader2 className="h-5 w-5 animate-spin" />
                {t("packing.aiGenerating")}
              </>
            ) : (
              <>
                <Bot className="h-5 w-5" />
                {t("packing.aiSuggestFull")}
              </>
            )}
          </Button>
          <p className="mt-2 text-center text-xs text-muted-foreground">
            {t("packing.aiSuggestDescription")}
          </p>
        </div>

        <div className="relative mb-4">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t" />
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-card px-2 text-muted-foreground">{t("packing.orSelectType")}</span>
          </div>
        </div>

        {/* Trip Type Template Grid */}
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {(Object.keys(TRIP_TYPE_TEMPLATES) as TripType[]).map((tripType) => {
            const config = TRIP_TYPE_TEMPLATES[tripType];
            const Icon = config.icon;
            return (
              <button
                key={tripType}
                onClick={() => onSelectTemplate(tripType)}
                disabled={isBulkCreating}
                className={`flex flex-col items-center gap-2 rounded-xl border-2 p-4 transition-all hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 ${config.color}`}
              >
                <Icon className="h-8 w-8" />
                <span className="text-sm font-medium">{t(config.labelKey)}</span>
                <span className="text-xs opacity-70">
                  {config.items.length}
                  {t("packing.itemCount")}
                </span>
              </button>
            );
          })}
        </div>

        {/* Or add manually */}
        <div className="mt-4 text-center">
          <p className="text-xs text-muted-foreground">{t("packing.orAddManually")}</p>
        </div>
      </CardContent>
    </Card>
  );
}
